// @flow

import * as React from 'react';
import { compose, withProps } from 'recompose';
import glamorous, { withTheme } from 'glamorous';
import { padding } from 'polished';
import RewriteNavLink from 'app/components/routing/RewriteNavLink';
import Pill from 'app/components/commons/Pill';
import StatusDot from 'app/components/commons/StatusDot';
import Tappable from 'app/components/commons/Tappable';
import Icon from 'app/components/commons/Icon';
import LivePill from 'app/components/styled/LivePill';

type Props = {
  activeStyle: Object,
  children?: any,
  icon: string,
  isLive?: boolean,
  isMarked?: boolean,
  isFree?: boolean,
  isNew?: boolean,
  onClick: (?string) => void,
  type?: string,
  url?: string
};

const MenuItem = glamorous(props => {
  switch (props.type) {
    case 'modal':
      return (
        <Tappable className={props.className} component="div" onTap={props.onClick}>
          {props.children}
        </Tappable>
      );
    case 'route':
      return (
        <RewriteNavLink
          activeStyle={props.activeStyle}
          className={props.className}
          to={props.url}
          onClick={props.onClick}
        >
          {props.children}
        </RewriteNavLink>
      );
    case 'external':
      return (
        <a target="_blank" className={props.className} href={props.url}>
          {props.children}
        </a>
      );
    default:
      return null;
  }
})(({ active, theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.color.basis1,
  borderColor: theme.color.primary,
  borderStyle: 'solid',
  borderWidth: 0,
  color: active ? theme.color.primary : theme.color.white,
  display: 'flex',
  fontSize: '1.05rem',
  fontWeight: theme.fontWeight.medium,
  height: 50,
  justifyContent: 'space-between',
  ...padding('0', 15),
  textTransform: 'uppercase',
  transition: 'background-color 0.2s, color 0.2s'
}));

const StyledNewPill = glamorous(Pill)({
  marginLeft: 'auto'
});

const Name = glamorous.span({
  paddingLeft: 5,
  paddingTop: 2
});

const LeftSide = glamorous.div({
  display: 'flex',
  alignItems: 'center'
});

class MobileMenuItem extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    children: undefined,
    isLive: false,
    isMarked: false,
    isFree: false,
    isNew: false,
    type: undefined,
    url: undefined
  };

  handleClick = () => {
    const { onClick, url } = this.props;
    onClick(url);
  };

  render() {
    const { activeStyle, children, icon, isFree, isLive, isMarked, isNew, type, url } = this.props;
    return (
      <MenuItem activeStyle={activeStyle} onClick={this.handleClick} type={type} url={url}>
        <LeftSide>
          <Icon type={icon} />
          <Name>{children}</Name>
        </LeftSide>
        {isNew && <StyledNewPill label="NEW" />}
        {isFree && <StyledNewPill label="FREE" kind="success" />}
        {isMarked && <StatusDot />}
        {isLive && <LivePill />}
      </MenuItem>
    );
  }
}

export default compose(
  withTheme,
  withProps(({ theme }) => ({
    activeStyle: {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      borderLeftWidth: 5,
      color: theme.color.primary,
      paddingLeft: 10
    }
  }))
)(MobileMenuItem);
